// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vue-star-rating-star{\n  height:2rem !important;\n  width:2rem !important\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
